<template>
  <section class="main">
    <section class="hero">
      <div class="wrapper">
        <img src="/kr/resume/static/renew_img/agree/hero.png" alt="이직활동 준비가 되었는지 체크리스트를 확인해줘!">
      </div>
    </section>
    <article class="wrapper" style="display: none;">
      <h2>
        <img src="/kr/resume/static/renew_img/agree/icon_check.svg" alt="icon_check">
        경력서 작성법은 잘 알고 있어?
      </h2>
      <div class="flex-box">
        <img src="/kr/resume/static/renew_img/agree/character1.png" alt="빨간펜인사부야기">
        <p>작성법, 표현방식 하나로 그 결과는 크게 달라진다. 진심으로 이직 하고 싶은 사람은 이곳을 주목해!</p>
      </div>
      <a href="#" class="btn_second">불합격하는 사람의 특징</a>
    </article>

    <article class="wrapper">
      <h2>
        <img src="/kr/resume/static/renew_img/agree/icon_check.svg" alt="icon_check">
        퇴사처리는 끝났나요?
      </h2>
      <div class="flex-box">
        <img src="/kr/resume/static/renew_img/agree/character2.png" alt="퇴직 대행 레인저 야기">
        <p>그만두고 싶은데 그만둘 수 없다... 원만히 퇴사하고 싶다, 등 상담 할 수 있습니다.!</p>
      </div>
      <a href="https://special.yagish.jp/taishoku/?utm_source=yagish&utm_medium=Collaboration2&utm_campaign=pop"
        class="btn_second" target="_blank">궁금한점을 상담 할 수 있습니다.</a>
    </article>

    <article class="wrapper">
      <h2>
        <img src="/kr/resume/static/renew_img/agree/icon_check.svg" alt="icon_check">
        효율적으로 일자리를 찾고 있습니까?
      </h2>
      <div class="flex-box">
        <p>야기슈로 작성한 이력서를 전송하여 보내 이직처에 대한 무료 상담을 해보세요!</p>
      </div>
      <p class="terms">
        Yagish의<a href="https://rirekisho.yagish.jp/terms" target="_blank">이용약관</a>,<a
          href="https://rirekisho.yagish.jp/privacy" target="_blank">개인정보보호</a>에 대하여<br>
        ㈜애드·탑의 이직지원서비스<a href="https://adtop-web.com/saiplus/agent/careerup/tos.html" target="_blank">이용약관</a>、<a
          href="https://adtop-web.com/privacypolicy.html" target="_blank">개인정보 취급</a>에 대하여
      </p>
      <el-button id="send-adtop-pdf" type="success" v-if="isSended == false" class="btn_cta"
        @click="$eventHub.$emit('send-adtop-consult');">모두 동의하고 무료상담 신청</el-button>
      <p class="terms">
        무료상담은 순차적으로 연락드리겠습니다.<br> 다소 시간이 걸릴수 있는 점을 알려 드립니다.
      </p>
      <a href="#" class="btn_dynamic">동의안함</a>
    </article>
    <a href="#" class="back">원래페이지로 이동</a>
  </section>
</template>
<style lang="css" src="@/assets/css/agree_reset.css"></style>
<style lang="css" src="@/assets/css/agree_stylesheet.css"></style>
<script>
export default {
  props: {
    formatId: {
      type: String
    },
    cardId: {
      type: String
    }
  },
  components: {
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isSended: false,
      fullscreenLoading: false
    }
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      this.updatePreviewHTML()
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    updatePreviewHTML: function () {
      console.error(this.formatId)
      console.error(this.cardId)
      if (this.$refs.previewFormat) {
        this.previewHtml = this.$refs.previewFormat.$el.innerHTML
      } else {
        console.error('this.$refs.previewFormat', this.$refs)
      }
      this.clearLocalStorageConfirmVisible = false
      if (id == "rirekisho_job_change" || id == "rirekisho_job_change2" || id == "shokumukeirekisho" || id == "rirekisho_nophoto_double" || id == "rirekisho_nophoto") {
        this.permissionType = 1
      } else if (id == "rerekisho_part_time" || id == "rirekisho_part_time2" || id == "rirekisho_single") {
        this.permissionType = 2
      }
    },
    closeDialog: function () {
      this.$modal.hide('adtop-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendAdtopConsult: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '현재 오프라인입니다.인터넷 연결 후 다시 시도해 보세요.',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: '로그인 해주세요.',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      console.log(accessToken)
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('yaginame', this.$yagi.profile.name)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('version', '2')
      formData.append('reqflg', '2')
      console.log(this.$firebase.config.apiKey)
      console.log(accessToken)
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.adtopPdfMail, formData, { timeout: 60000 })
        .then(function (response) {
          app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `담당자가 당신의 이메일 주소로 입사 제안을 할 수 있습니다.`,
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '전송을 실패하였습니다.',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendAdtopScout: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '현재 오프라인입니다.인터넷 연결 후 다시 시도해 보세요.',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: '로그인 해주세요.',
          type: 'warning'
        })
        return
      }
      const formData = this.pdfFormData
      console.log(accessToken)
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('yaginame', this.$yagi.profile.name)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('version', '2')
      formData.append('reqflg', '1')
      console.log(this.$firebase.config.apiKey)
      console.log(accessToken)
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.adtopPdfMail, formData, { timeout: 60000 })
        .then(function (response) {
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `담당자가 당신의 이메일 주소로 입사 제안을 할 수 있습니다.`,
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '전송을 실패하였습니다.',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
        })
    }
  },
  beforeMount: function () {
    console.error(this.$route.params.cardId)
    console.error(this.$route.params.formatId)
    this.$eventHub.$on('send-adtop-consult', this.sendAdtopConsult)
    this.$eventHub.$on('send-adtop-scout', this.sendAdtopScout)
    this.$eventHub.$on('open-adtop-dialog', this.openDialog)
    this.$eventHub.$on('popstate', this.closeDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-adtop-consult', this.sendAdtopConsult)
    this.$eventHub.$off('send-adtop-scout', this.sendAdtopScout)
    this.$eventHub.$off('open-adtop-dialog', this.openDialog)
    this.$eventHub.$off('popstate', this.closeDialog)
  }
}
</script>
